<template>
  <div class="box">
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>今日值班人员</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.id ? '编辑' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" size="small" style="position: absolute;top: 15px; right: 25px" @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="bodyBox">
      <div style="display:flex">
        <div style="margin-top: 11px">值班领导：</div>
        <div>
          <el-form :inline="true" :model="item" class="demo-form-inline" v-for="(item,index) in leaderArr" :key="index">
            <el-form-item>
              <el-select v-model="item.name" placeholder="请选择值班领导" size="small" style="width: 500px">
                <el-option v-for="people in peopleList" :key="people" :label="people" :value="people"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="item.number" placeholder="请填写电话" size="small" style="width: 223px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" size="small" @click="leaderDel(index)">删除</el-button>
            </el-form-item>
          </el-form>
          <el-button plain size="small"
            :style="{marginTop: (leaderArr.length === 0 ? '6px' : '0' )}"
            style="width: 800px;border:1px #999999 dashed" @click="addLeader">新增
          </el-button>
        </div>
      </div>
      



      <div style="display:flex;margin-top: 30px">
        <div style="margin-top: 11px">值班人员：</div>
        <div>
          <el-form :inline="true" :model="item" class="demo-form-inline" v-for="(item,index) in dutyOfficerArr" :key="index">
            <el-form-item>
              <el-select v-model="item.name" placeholder="请选择值班人员" size="small" style="width: 500px">
                <el-option v-for="people in peopleList" :key="people" :label="people" :value="people"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="item.number" placeholder="请填写电话" size="small" style="width: 223px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" size="small" @click="dutyOfficerDel(index)">删除</el-button>
            </el-form-item>
          </el-form>
          <el-button plain size="small"
            :style="{marginTop: (dutyOfficerArr.length === 0 ? '6px' : '0' )}"
            style="width: 800px;border:1px #999999 dashed" @click="addDutyOfficer">新增</el-button>
        </div>
      </div>


      <el-form style="margin-top: 30px;margin-left:16px">
        <el-form-item label="时间：">
          <div class="block">
            <el-date-picker size="small"
              v-model="value3"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>


      <div style="text-align: center;margin-top: 30px">
        <el-button type="primary" size="small" style="width: 400px" @click="submit">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addJrzbData, getPeopleList, edithJrzbData } from '@/api/processHome'
export default {
  name: 'JrzbAdd',
  data() {
    return {
      leaderArr: [
        // { name: '', number: '' },
      ],
      dutyOfficerArr: [
        // { name: '', number: '' }
      ],
      peopleList: [], // 获取到的人员下拉框的列表
      value3: [],
    }
  },
  methods: {
    // 添加领导人
    addLeader() {
      this.leaderArr.push({
        name: '',
        number: ''
      })
    },
    // 添加值班人员
    addDutyOfficer() {
      this.dutyOfficerArr.push({
        name: '',
        number: ''
      })
    },
    // 删除某一个值班领导
    leaderDel(index) {
      this.leaderArr.splice(index, 1)
    },
    // 删除某一个值班人员
    dutyOfficerDel(index) {
      this.dutyOfficerArr.splice(index, 1)
    },
    // 保存按钮
    submit() {
      let obj = {}
      obj.dutyLeader = JSON.stringify(this.leaderArr)
      obj.dutyEmployees = JSON.stringify(this.dutyOfficerArr)
      // console.log(this.value3)
      if(this.value3 === null) {
        this.$message.error('日期是必填选项')
        return
      }
      obj.showTimeStart = this.value3[0]
      obj.showTimeEnd = this.value3[1]
      // console.log(obj)
      if(obj.showTimeStart === undefined || obj.showTimeEnd === undefined){
        this.$message.error('日期是必填选项')
        return
      }
      // 修改
      if(this.$route.query.id){
        obj.id = this.$route.query.id
        edithJrzbData(obj).then(res => {
          this.$message.success(res.body.msg)
          this.$router.push('JrzbSearch')
        })
      } else {
        // 新增
        addJrzbData(obj).then(res => {
          this.$message.success(res.body.msg)
          this.$router.push('JrzbSearch')
        })
      }
    }
  },
  created() {
    if(this.$route.query.id) {
      let obj = this.$route.query
      this.leaderArr = obj.dutyLeader
      this.dutyOfficerArr = obj.dutyEmployees
      this.value3.push(obj.showTimeStart)
      this.value3.push(obj.showTimeEnd)
    }
    // 获取下拉人员列表
    getPeopleList({limit: 100, curPage: 1}).then(res => {
      let arr = res.body.data
      let newArr = []
      arr.forEach(item => {
        newArr.push(item.nickname)
      })
      this.peopleList = newArr
    })
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  /* height: 100%; */
  background-color: white;
  padding: 25px;
}
.head {
  /* position: absolute;
  top: 0px;
  left: 250px; */
  width: calc(100% - 250px);
}
.bodyBox {
  width: 950px;
  height: 100%;
  /* border: 1px solid black; */
  margin: auto;
}
.bodyBox /deep/ .el-form-item {
  margin-bottom: 0
}
</style>